<template>
    <div class="container-xl" v-if="!$store.getters.isForbidden">
      <div class="card">
        <div class="card-header border-0 justify-content-between">
          <div class="card-title">{{ $route.name }} List</div>
          <div class="flex flex-row mb-2 pr-2 float-right">
            <el-input clearable @clear="searchHandler" style="width: 200px" size="small" type="text" v-model="search_keyword" placeholder="Input search keyword" class="mr-2"/>
            <el-select size="small" v-model="merchant_status" placeholder="Merchant Status" class="mr-2" filterable style="width: 100px">
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button type="primary" @click="searchHandler" size="small"><font-awesome-icon icon="search"/> Search</el-button>
            <!-- <el-button type="primary" @click="clikCreateMerchant" size="small"><font-awesome-icon icon="plus"/> Create Merchant</el-button> -->
          </div>
        </div>
        <div class="table-responsive">
          <table class="table card-table text-nowrap table-vcenter">
            <thead>
              <tr>
                <th width="10%">Invoice Date</th>
                <th width="20%">Invoice Number</th>
                <th width="20%">Merchant Name</th>
                <th width="10%">Item Quantity</th>
                <th>Amount</th>
                <th width="5%">Status</th>
                <!-- <th width="5%">Merchant Apps Status</th> -->
                <th width="10%">#</th>
              </tr>
            </thead>
            <tbody v-loading="isLoading">
              <tr v-for="(item, i) in list" :key="i">
                <td>{{ item.created_at_str }}</td>
                <td>{{ item.invoice_number }}</td>
                <td>{{ item.merchant_name }}</td>
                <td>{{ item.total_trx }}</td>
                <td>Rp. {{ (item.amount).toLocaleString() }}</td>
                <td><span class="tag" :style="{ 'background-color': item.status_detail ? item.status_detail.status_color : '', color: '#fff' }">{{ item.status_detail ? item.status_detail.status_message : '-' }}</span></td>
                <td>
                  <el-button type="text" size="mini" @click="() => $router.push({ name: 'Merchants App Invoice Detail', params: { id: item.id } })">View</el-button>
                </td>
              </tr>
            </tbody>
          </table>
          <el-empty description="No data found" v-if="total_rows == 0" :image="emptyStateImage"></el-empty>
        </div>
        <div class="card-footer d-flex justify-content-between">
          <small>Showing {{ showingFrom }} to {{ showingUntil }} of {{ total_rows }} entries</small>
          <div class="inline-table">
            <b-pagination
              class="table-cell"
              @change="pageChangeHandler"
              :per-page="per_page"
              :limit="5"
              :total-rows="total_rows"
              v-model="page"
            />
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import { cloneDeep } from 'lodash';
import crypto from 'crypto';
import moment from 'moment';
import {
  required, requiredIf, numeric, email, minLength, helpers, maxLength,
} from '@vuelidate/validators';

import { CREATE_MERCHANT, UPDATE_MERCHANT, MERCHANT_INVOICE_LIST } from '@/store/modules/merchants';
import { GET_CATEGORYS } from '@/store/modules/categorys';
import emptyStateImage from '@/assets/images/empty-state.png';
import base64File from '@/library/base64File';
import popupErrorMessages from '@/library/popup-error-messages';
import imageCompress from '@/library/vue-image-compression';
import passwordComplexity from '@/library/password-complexity';

export default {
  name: 'MerchantAppsInvoice',
  metaInfo: {
    title: 'Merchant Apps Invoice',
  },
  components: {
  },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      emptyStateImage,
      merchantList: [],
      loading: {
        modal_merchant: false,
      },
      editorOption: {
        placeholder: 'Input merchant description',
      },
      merchant_id: '',
      filter_merchant_loading: false,
      per_page: 20,
      total_rows: 0,
      page: 1,
      list: [],
      isLoading: true,
      loader: null,
      search_keyword: '',
      search_by: '',
      search_merchant_keyword: '',
      selected_file: {
        merchant_banner: null,
        merchant_banner_base64: null,
        merchant_photo_url: null,
        merchant_photo_url_base64: null,
      },
      merchant_status: '',
      categoryList: [],
      total_rows_category: 0,
      statusOptions: [
        {
          value: '',
          label: 'All',
        },
        {
          value: 'active',
          label: 'Active',
        },
        {
          value: 'inactive',
          label: 'Inactive',
        },
      ],
      form: {
        merchant_name: '',
        merchant_address: '',
        merchant_pic: '',
        merchant_telp: '',
        merchant_description: '',
        merchant_photo_url: '',
        merchant_banner: '',
        merchant_logo: '',
        merchant_category_id: '',
        is_highlight: false,
        is_homepage_highlight: false,
        is_registered_merchant_app: true,
        merchant_is_top_list: 0,
        merchant_brand_code: '',
        merchant_pic_telp: '',
        merchant_pic_email: '',
        merchant_pic_password: '',
        merchant_margin_fee_amount: null,
        merchant_margin_fee: '',
      },
      modalTitle: 'Create new Merchant',
      showModalMerchant: false,
    };
  },
  validations() {
    return {
      form: {
        merchant_name: { required },
        merchant_address: { required },
        merchant_pic: { required },
        merchant_telp: { required },
        merchant_description: { required },
        merchant_photo_url: { required },
        merchant_category_id: { required },
        merchant_banner: { required },
        merchant_brand_code: {
          required,
          maxLength: maxLength(10),
          minLength: minLength(3),
        },
        merchant_pic_telp: {
          required: requiredIf(this.form.is_registered_merchant_app),
          numeric,
        },
        merchant_pic_email: {
          required: requiredIf(this.form.is_registered_merchant_app),
          email,
        },
        merchant_pic_password: {
          required: requiredIf(this.form.is_registered_merchant_app && this.modalType === 'add'),
          minLength: minLength(this.modalType === 'add' ? 8 : 0),
          complexity: helpers.withMessage(() => 'Password should have at least 1 uppercase, 1 lowercase, 1 number and 1 special character', passwordComplexity),
        },
        merchant_margin_fee: {
          required: requiredIf(this.form.is_registered_merchant_app),
        },
        merchant_margin_fee_amount: {
          required: requiredIf(this.form.is_registered_merchant_app),
          numeric,
        },
      },
    };
  },
  computed: {
    showingFrom() {
      return this.total_rows ? ((this.page - 1) * this.per_page) + 1 : 0;
    },
    showingUntil() {
      if (this.total_rows) {
        if (this.list.length < this.per_page) {
          return this.total_rows;
        }
        return this.page * this.per_page;
      }
      return 0;
    },
  },
  async mounted() {
    const loader = this.$loading.show();
    await this.getList();
    loader.hide();
  },
  methods: {
    pageChangeHandler(page) {
      this.page = page;
      this.getList();
    },
    searchHandler() {
      this.page = 1;
      this.search_by = 'merchant_name';
      this.getList();
    },
    async getList() {
      this.isLoading = true;
      await this.$store.dispatch(MERCHANT_INVOICE_LIST, {
        id: 'all',
        query: {
          page: this.page,
          per_page: this.per_page,
          search_by: this.search_by,
          search_keyword: this.search_keyword,
          status_filter: this.merchant_status,
          is_registered_merchant_app: true,
        },
      }).then(({ data: response }) => {
        const { count, rows } = response;
        this.total_rows = count || 0;
        this.list = rows.map((v) => {
          v.created_at_str = moment(v.created_at).format('DD MMM YYYY');
          v.merchant_name = v.merchant.merchant_name;
          v.merchant_app_status_str = v.is_registered_merchant_app ? 'Registered' : 'Not Registered';
          v.merchant_app_status_color = v.is_registered_merchant_app ? 'tag-primary' : 'tag-default';
          return v;
        });
      }).catch(() => {});
      this.isLoading = false;
    },
    clickEditMerchant(item) {
      this.modalType = 'edit';
      this.modalTitle = 'Edit Merchant';
      this.showModalMerchant = true;
      this.getCategoryList();
      this.form = cloneDeep(item);
      this.form.is_registered_merchant_app = true;
      this.form.current_merchant_banner = item.merchant_banner;
      this.form.current_merchant_photo_url = item.merchant_photo_url;
      /* eslint-disable radix */
      this.form.merchant_margin_fee_amount = parseInt(this.form.merchant_margin_fee * 100);
      this.v$.form.$touch();
    },
    clikCreateMerchant() {
      this.modalType = 'add';
      this.modalTitle = 'Create New Merchant';
      this.showModalMerchant = true;
      this.getCategoryList();
      this.v$.form.$touch();
    },
    closeModalMerchant() {
      this.showModalMerchant = false;
      this.form = {
        merchant_name: '',
        merchant_address: '',
        merchant_pic: '',
        merchant_telp: '',
        merchant_description: '',
        merchant_photo_url: '',
        merchant_banner: '',
        merchant_logo: '',
        merchant_category_id: '',
        is_highlight: false,
        is_homepage_highlight: false,
        is_registered_merchant_app: true,
        merchant_is_top_list: 0,
        merchant_brand_code: '',
        merchant_pic_telp: '',
        merchant_pic_email: '',
        merchant_pic_password: '',
        merchant_margin_fee: '',
        merchant_margin_fee_amount: null,
      };
    },
    onSubmitMerchant() {
      if (this.form.is_registered_merchant_app) {
        this.form.merchant_margin_fee = this.form.merchant_margin_fee_amount / 100;
      }
      this.v$.form.$touch();
      if (this.v$.form.$error) {
        return;
      }
      let msg = 'You will create new merchant. Continue?';
      if (this.modalType === 'edit') {
        msg = 'You will update this merchant data. Continue?';
      }
      this.$confirm(msg, 'Confirmation', {
        type: 'info',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            if (this.modalType === 'add') {
              this.createMerchant();
            } else if (this.modalType === 'edit') {
              this.updateMerchant();
            }
          }
          done();
        },
      }).catch(() => {});
    },
    async createMerchant() {
      this.loading.modal_merchant = true;
      const category = this.categoryList.find((v) => v.category_id === this.form.merchant_category_id);
      this.form.merchant_category_str = category?.category_name;
      if (this.form.is_registered_merchant_app) {
        this.form.merchant_margin_fee = this.form.merchant_margin_fee_amount / 100;
      }
      await this.$store.dispatch(CREATE_MERCHANT, this.form)
        .then(() => {
          this.$message({
            title: 'Success',
            type: 'success',
            message: 'Merchant successfully created',
          });
          this.showModalMerchant = false;
        })
        .catch((err) => {
          popupErrorMessages(err.response.data);
        });
      this.getList();
      this.loading.modal_merchant = false;
    },
    async updateMerchant() {
      if (this.form.is_registered_merchant_app) {
        this.form.merchant_margin_fee = this.form.merchant_margin_fee_amount / 100;
      }
      this.loading.modal_merchant = true;
      await this.$store.dispatch(UPDATE_MERCHANT, {
        id: this.form.merchant_id,
        data: this.form,
      }).then(() => {
        this.$message({
          title: 'Success',
          type: 'success',
          message: 'Merchant successfully updated',
        });
        this.getList();
      }).catch((err) => {
        popupErrorMessages(err.response.data);
      });
      this.loading.modal_merchant = false;
      this.showModalMerchant = false;
    },
    async onChangeFile(event, target) {
      if (this.selected_file[target]) {
        const compressed = await imageCompress(this.selected_file[target]);
        this.selected_file[`${target}_base64`] = await base64File(compressed);
        try {
          this.$refs[`current_${target}`].src = this.selected_file[`${target}_base64`];
          this.form[`current_${target}`] = this.selected_file[`${target}_base64`];
          this.form[target] = this.form[`current_${target}`];
        } catch (error) {
          // console.log(error);
        }
      }
    },
    async toggleMerchantStatus(item) {
      let msg = 'Are you sure want to activate this merchant?';
      if (item.merchant_status === 1) {
        msg = 'Are you sure want to inactivate this merchant?';
      }
      this.$confirm(msg, 'Confirmation', {
        type: 'info',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            await this.$store.dispatch(UPDATE_MERCHANT, {
              id: item.merchant_id,
              data: {
                merchant_status: item.merchant_status === 1 ? 0 : 1,
              },
            }).then(() => {
              this.$message({
                title: 'Success',
                type: 'success',
                message: 'Merchant successfully updated',
              });
            }).catch((err) => {
              popupErrorMessages(err.response.data);
            });
            instance.confirmButtonLoading = false;
            done();
            this.getList();
            return;
          }
          done();
        },
      }).catch(() => {});
    },
    async getCategoryList() {
      await this.$store.dispatch(GET_CATEGORYS, {
        search_by: 'category_type',
        search_keyword: '1',
      }).catch((err) => console.log(err));
      const { rows, count } = this.$store.getters.categorys;
      this.total_rows_category = count || 0;
      this.categoryList = rows;
    },
    handlerClickGeneratePassword() {
      try {
        this.form.merchant_pic_password = this.generateRandomPassword();
        this.v$.form.$touch();
      } catch (error) {
        console.log(error);
      }
    },
    generateRandomPassword() {
      const wishlist = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
      const wishlist_number = '0123456789';
      const wishlist_symbol = '~!@()#$';
      // const length = 10;
      const normal_char = Array.from(crypto.randomFillSync(new Uint8Array(8))).map((x) => wishlist[x % wishlist.length]).join('');
      const number_char = Array.from(crypto.randomFillSync(new Uint8Array(1))).map((x) => wishlist_number[x % wishlist_number.length]).join('');
      const symbol_char = Array.from(crypto.randomFillSync(new Uint8Array(1))).map((x) => wishlist_symbol[x % wishlist_symbol.length]).join('');
      return normal_char + number_char + symbol_char;
    },
    handleCommand(fn, item) {
      this[fn](item);
    },
  },
};
</script>
